import React, { useEffect, useState } from "react";
import fetchPrintingData from "./Services/fetchPrintingData";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
//import { serverConfig } from "../ApiSourcePath/ApiSourcePath";
import "./CSS/PrintPrescript.css";

const PrescriptionPrint = ({appointmentId,printWindow}) => {
  const [data, setData] = useState(null);
  const [pages, setPages] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const dto = await fetchPrintingData(appointmentId);
      setData(dto);
    };
    loadData();
  }, [appointmentId]);

  useEffect(() => {
    if (data) {
      const pages = [];
      let currentPageContent = [];
      let currentItemCount = 0;
      let currentPageIndex = 0;
      const getMaxItemsPerPage = () => (currentPageIndex === 0 ? 22 : 26);
      const startNewPage = () => {
        if (currentPageContent.length > 0) {
          pages.push([...currentPageContent]);
          currentPageContent = [];
          currentItemCount = 0;
          currentPageIndex += 1;
        }
      };
const sentenceCase = (str) => 
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      const patientInfo = `
        <section class="patient-info">
          <table style="width: 100%; border-collapse: collapse; font-size: 16px; margin-bottom: 10px;margin-left:0px;">
            <tr>
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">Name:</strong> <strong>${data?.patientName || ""}</strong></td>
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">Age:</strong> <strong>${data?.age || ""}</strong></td>
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">Sex:</strong> <strong>${data?.sex || ""}</strong></td>
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">Phone:</strong> <strong>${data?.phone || ""}</strong></td>
            </tr>
            <tr style="border-bottom:1px solid #000;">
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">Address:</strong> <strong>${data?.address || ""}</strong></td>
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">Weight:</strong> <strong>${(data?.weight!=='')?data?.weight+" Kg" : ""}</strong></td>
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">BP:</strong> <strong>${(data?.bp!=='')? data?.bp+" mmHg" : ""}</strong></td> 
              <td style="padding: 6px 6px 6px 0;"><strong style="color:#000;">Date:</strong> <strong>${data?.date || ""}</strong></td>
            </tr>
          </table>
        </section>
      `;

      // const doctorInfo = `
      //   <section class="doctor-info" style="font-size:16px;">
      //     <div style="display: flex; justify-content: space-between;">
      //       <p style="text-align: right;width:100%;margin-top:3px !important;margin-bottom:3px !important;"><strong>Date:</strong> ${data?.date || ""}</p>
      //     </div>
      //   </section>
      // `;
      //currentPageContent.push(patientInfo,doctorInfo);
      currentPageContent.push(patientInfo);
      currentItemCount += 4;

      const sections = [
        { label: "Diagnosis :", key: "diagnosis", isList: true, isDiagnosis: true },
        { label: "Investigation :", key: "tests", isList: true },
        { label: "Treatment/Procedure :", key: "procedures", isList: true, isTreatment:true },
        { label: "Medicine :", key: "medicines", isList: true, isMedicine: true },
        { label: "Remarks :", key: "remarks", isList: false, isRemark: true },
      ];
      // sections.forEach((section) => {
      //   // Skip section if data is not present or empty, but allow Remarks if nextReviewDate exists
      //   if (!section.isRemark && (!data?.[section.key] || (Array.isArray(data[section.key]) && data[section.key].length === 0))) {
      //     return;
      //   }
      //   if (section.isRemark && (!data[section.key]?.trim() && !data.nextReviewDate)) {
      //     return;
      //   }

      //   let sectionContent = (section.isDiagnosis) ? [`<section class="data-section" style="font-size:16px;"><h4 style="margin-top:5px !important;">${section.label}</h4>`] : 
      //                      (section.isRemark && (!data[section.key]?.trim()) && data.nextReviewDate) ? 
      //                      [`<section class="data-section" style="font-size:16px;">`] : 
      //                      [`<section class="data-section" style="font-size:16px;"><h4>${section.label}</h4>`];
      //   let sectionItems = [];

      //   if (section.isRemark) {
      //     console.log('remarks--');
      //     const remarkText = data[section.key] || "";
      //     const safeRemarkText = remarkText ?? "";
      //     const remarkLines = safeRemarkText.split(/[.\n]+/).filter((line) => line.trim());
      //     const nextReview = (data?.nextReviewDate) ? `<p style="text-align: right; font-size: 16px;"><b>Next Review Date: ${data?.nextReviewDate || ""}</b></p>` : "";
          
      //     // Include remarks only if there are remark lines or nextReview exists
      //     if (remarkLines.length > 0 || nextReview) {
      //       sectionItems = [
      //         ...remarkLines.map((line) => `<p style="font-size: 16px !important;"><b>${line.trim()}</b></p>`),
      //         nextReview
      //       ].filter(item => item); // Filter out empty nextReview
      //     } else {
      //       return; // Skip if both are empty (though this is already handled above)
      //     }
      //   } else {
      //     if (section.isMedicine) {
      //       sectionItems = [
      //         `<div style="font-weight: bold; margin-bottom: 5px;font-size:19px">℞</div>`,
      //         ...data[section.key].map((item, index) =>
      //           `<li style="margin-bottom: 5px;"><span style='font-size:16px;text-transform:uppercase;'><b>${index + 1}. ${item.name}</b></span> -<span class='medicenes-about'>&nbsp;&nbsp;&nbsp; ${sentenceCase(item.instructions)}</span></li>`
      //         )
      //       ];
      //     } else if(section.isTreatment) {
      //       sectionItems = data[section.key].map((item, index) =>
      //         `<li style="margin-bottom:5px;font-size:16px;text-transform:uppercase;">${index + 1}. ${item}</li>`
      //       );
      //     }
      //     else {
      //       sectionItems = data[section.key].map((item, index) =>
      //         `<li style="margin-bottom: 5px;font-size:16px;text-transform:uppercase;"><b>${index + 1}. ${item}</b></li>`
      //       );
      //     }
      //   }

      //   if (section.isList) {
      //     sectionContent.push('<ul style="padding-left: 80px; list-style-type: none; margin: 0;">');
      //   }

      //   sectionItems.forEach((item) => {
      //     if (currentItemCount >= getMaxItemsPerPage()) {
      //       if (section.isList) sectionContent.push("</ul>");
      //       sectionContent.push("</section>");
      //       currentPageContent.push(sectionContent.join(""));
      //       startNewPage();
      //       sectionContent = [`<section class="data-section" style="font-size:16px;margin-top:10px"><h4>${section.label}</h4>`];
      //       if (section.isList) {
      //         sectionContent.push('<ul style="padding-left: 80px;list-style-type:none;margin: 0;">');
      //       }
      //     }
      //     sectionContent.push(item);
      //     currentItemCount += 1;
      //   });

      //   if (sectionContent.length > 1) {
      //     if (section.isList) sectionContent.push("</ul>");
      //     sectionContent.push("</section>");
      //     currentPageContent.push(sectionContent.join(""));
      //   }
      // });
      sections.forEach((section) => {
  // Skip section if data is not present or empty, but allow Remarks if nextReviewDate exists
  if (!section.isRemark && (!data?.[section.key] || (Array.isArray(data[section.key]) && data[section.key].length === 0))) {
    return;
  }

  let sectionContent;
  let sectionItems = [];

  if (section.isRemark) {
    const remarkText = data[section.key] || "";
    const safeRemarkText = remarkText ?? "";
    const remarkLines = safeRemarkText.split(/[.\n]+/).filter((line) => line.trim());
    const hasRemarkLines = remarkLines.length > 0;

    if (!hasRemarkLines) {
      return;
    }

    // Set sectionContent based on content
    if (section.isDiagnosis) {
      sectionContent = [`<section class="data-section" style="font-size:16px;"><h4 style="margin-top:5px !important;">${section.label}</h4>`];
    }  else {
      sectionContent = [`<section class="data-section" style="font-size:16px;"><h4>${section.label}</h4>`];
    }

    // Build sectionItems for remarks with conditional extra lines
    if (hasRemarkLines) {
      sectionItems = remarkLines.map((line) => `<p style="font-size: 16px !important;"><b>${line.trim()}</b></p>`);
      
    }
    
  } else {
    // Non-remarks sections (unchanged)
    if (section.isMedicine) {
      sectionItems = [
        `<div style="font-weight: bold; margin-bottom: 5px;font-size:19px">℞</div>`,
        ...data[section.key].map((item, index) =>
          `<li style="margin-bottom: 5px;"><span style='font-size:16px;text-transform:uppercase;'><b>${index + 1}. ${item.name}</b></span> -<span class='medicenes-about'>&nbsp;&nbsp;&nbsp; ${sentenceCase(item.instructions)}</span></li>`
        )
      ];
    } else if (section.isTreatment) {
      sectionItems = data[section.key].map((item, index) =>
        `<li style="margin-bottom:5px;font-size:16px;text-transform:uppercase;">${index + 1}. ${item}</li>`
      );
    } else {
      sectionItems = data[section.key].map((item, index) =>
        `<li style="margin-bottom: 5px;font-size:16px;text-transform:uppercase;"><b>${index + 1}. ${item}</b></li>`
      );
    }

    // Set sectionContent for non-remarks (unchanged, but moved here for structure)
    if (section.isDiagnosis) {
      sectionContent = [`<section class="data-section" style="font-size:16px;"><h4 style="margin-top:5px !important;">${section.label}</h4>`];
    } else {
      sectionContent = [`<section class="data-section" style="font-size:16px;"><h4>${section.label}</h4>`];
    }
  }

  if (section.isList) {
    sectionContent.push('<ul style="padding-left: 80px; list-style-type: none; margin: 0;">');
  }

  sectionItems.forEach((item) => {
    if (currentItemCount >= getMaxItemsPerPage()) {
      if (section.isList) sectionContent.push("</ul>");
      sectionContent.push("</section>");
      currentPageContent.push(sectionContent.join(""));
      startNewPage();
      sectionContent = [`<section class="data-section" style="font-size:16px;margin-top:10px"><h4>${section.label}</h4>`];
      if (section.isList) {
        sectionContent.push('<ul style="padding-left: 80px;list-style-type:none;margin:0;">');
      }
    }
    sectionContent.push(item);
    currentItemCount += 1;
  });

  if (sectionContent.length > 1) {
    if (section.isList) sectionContent.push("</ul>");
    sectionContent.push("</section>");
    currentPageContent.push(sectionContent.join(""));
  }
});
      if (currentPageContent.length > 0) {
        pages.push(currentPageContent);
      }

      setPages(pages);
    }
  }, [data]);

  // Trigger print in the printWindow
  useEffect(() => {
    if (pages.length > 0 && printWindow) {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
       // window.location.reload();
      }, 500); // Small delay to ensure rendering is complete
    }
  }, [pages, printWindow]);
  if (!data) return <div>Loading...</div>;

  return (
    <>
      <style>
        {`
          .medicenes-about {
              font-size:15px;  
          }
          
.print-page {
  width: 800px;
  margin: 0;
  position: relative;
  font-family: 'Segoe UI', sans-serif;
  page-break-after: always;
}

.print-header {
  width: 100%;
  height: 180px;
  background-color: white;
  //border-top: 1px solid #ccc;
  //border-bottom: 1px solid #ccc;
}

.print-footer {
  width: 100%;
  height: 200px;
  background-color: white;
  //border-top: 1px solid #ccc;
  //border-bottom: 1px solid #ccc;
}
  .print-review-date {
     width:100%;
     height:30px;
     padding-top:5px;
     background-color:white;
  }

.print-body {
  padding: 15px;
  position: relative;
  background-color: white;
}

.data-section {
  margin-bottom: 10px;
  page-break-inside: avoid;
  line-height: 22px;
}

.data-section h4 {
  margin-bottom: 8px;
  //border-bottom: 1px solid #eee;
  color: #000;
}

.data-section ul {
  padding-left: 80px !important;
  list-style-type: none;
  margin: 0;
}

.data-section li {
  margin-bottom: 10px;
  font-size: 16px;
}

.data-section p {
  margin: 5px 0;
  font-size: 16px;
}

@media print {
  body {
    margin: 0;
  }

  .print-page {
    page-break-after: always;
    position: relative;
  }

  .print-header {
    position: fixed;
    top: 0;
    height: 180px;
    width: 100%;
  }

  .print-footer {
    position: fixed;
    bottom: 0;
    height: 187px;
    width: 100%;
  }

  .print-body {
    margin-top: 180px;
    margin-bottom: 250px;
    padding: 20px;
    page-break-inside: auto;
  }
.print-review-date {
    position: fixed;
    bottom: 200px; /* Positions bottom of review date at the top edge of the footer */
    height: 30px;
    width: 100%;
    padding-top:5px;
    padding-right: 30px;
    background-color: white;
    z-index: 1; /* Ensures it layers above content if needed */
  }
  .data-section {
    margin-left:80px;
    page-break-inside: avoid;
  }

  .data-section ul {
    padding-left: 80px !important;
    margin: 0;
    list-style-type: none;
  }
}
`}
      </style>

      {pages.map((pageContent, pageIndex) => (
        <div key={pageIndex} className="print-page">
          <header className="print-header">
            <img
              src={`${serverConfig.BASE_URL}/Uploads/company/${data?.companyHeaderImage}`}
              alt="Header"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
               onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/headerCompany.png";
  }}
            />
          </header>
          <main className="print-body">
            <div dangerouslySetInnerHTML={{ __html: pageContent.join("") }} />
            
            
          </main>
             {/* Show Next Review Date only on LAST page */}
    {data?.nextReviewDate && pageIndex === pages.length - 1 && (
      <div className="print-review-date">
        <p style={{ textAlign: "right", fontSize: "16px" }}>
          <b>Next Review Date: {data.nextReviewDate}</b>
        </p>
      </div>
    )}
          <footer className="print-footer">
            <img
              src={`${serverConfig.BASE_URL}/uploads/company/${data?.companyFooterImage}`}
              alt="Footer"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
               onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/footerCompany.png";
  }}
            />
          </footer>
        </div>
      ))}
    </>
  );
};

export default PrescriptionPrint;